import { LoaderFunction, redirect } from "react-router-dom";

import { orgStorage } from "@/shared/auth";
import { DatasetRecord } from "@/shared/domain/datasets";
import { QueryService, QueryTarget } from "@/shared/domain/query";
import { makeAuthenticatedHttpClient } from "@/shared/http/makeAuthenticatedHttpClient";
import { Goto } from "@/shared/navigation/Goto";
import { ErrorMonitoringService } from "@/shared/services";

export type DatasetByNameLoaderData = {
  datasetId: string;
};

export const loadDatasetByName: LoaderFunction = async ({
  params,
}): Promise<DatasetByNameLoaderData | Response> => {
  try {
    const { datasetName } = params;
    const httpClient = await makeAuthenticatedHttpClient();

    const queryService = new QueryService(httpClient);
    const orgRecord = orgStorage.getCurrentOrg();

    // Redirect user to select orgs if org not found
    if (!orgRecord) {
      return redirect(`${Goto.route.SignIn}?chooseorg=true`);
    }
    const query = await queryService.submitRoboql(
      {
        target: QueryTarget.Datasets,
        query: `name = "${datasetName}"`,
      },
      { resourceOwnerId: orgRecord.org_id },
    );

    const resultCount = await queryService.getQueryResultCount(query.query_id);
    if (resultCount !== 1) {
      return redirect(`${Goto.route.Search}?queryId=${query.query_id}`);
    }

    const results = await queryService.getQueryResults(query.query_id);
    const datasetId = (results.items[0] as DatasetRecord).dataset_id;
    return { datasetId };
  } catch (error) {
    // Go to the full datasets list when an error occurs.
    ErrorMonitoringService.captureError(error);
    return redirect(Goto.route.Datasets);
  }
};
